import { NextSeo } from 'next-seo';
import { FC } from 'react';

import { SlugIdParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResource } from '@/lib/datx-jsonapi-react';
import { getOriginalSeries } from '@/queries/originals-series';

export const OriginalsPageSeo: FC = () => {
  const { id: originalsId } = useQueryParams<{ id: string }>({
    id: SlugIdParam,
  });

  const { data } = useResource(getOriginalSeries(originalsId));

  return (
    <NextSeo
      title={data.title}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_BASE_URL}originals/${data.id}-${data.slug}`,
        title: data.title,
        description: data.description,
        images: [
          {
            url: data.mediumHeaderImageUrl || `${process.env.NEXT_PUBLIC_BASE_URL}images/landing/hero-share.jpg`,
            width: 800,
            height: 600,
            alt: `Photo - ${data.title}`,
          },
        ],
      }}
    />
  );
};
